module.exports = __webpack_public_path__ + "img/1-1-1.b06800d3.png";